import { render, staticRenderFns } from "./ToggleTable.vue?vue&type=template&id=8b3bb316&"
import script from "./ToggleTable.vue?vue&type=script&lang=js&"
export * from "./ToggleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports